import React from "react";
import PropTypes from 'prop-types';

var ShareEmail = function ShareEmail(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 19 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 15 : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#444749' : _ref$fill;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 19 15",
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    d: "M17 0H2C.9 0 .01.9.01 2L0 13c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 4L9.5 9 2 4V2l7.5 5L17 2v2z"
  }));
};

ShareEmail.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string
};
export default ShareEmail;